import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=3d782fb4"
var script = {}
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=3d782fb4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports